import React from 'react';
import { useTranslation } from 'react-i18next';

const ProtectedRoute = ({ userRole, requiredRoles, children }) => {
  const { t } = useTranslation();
  // Защита от неправильных пропсов
  if (!Array.isArray(requiredRoles)) {
    console.error('ProtectedRoute: requiredRoles должен быть массивом', requiredRoles);
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500 font-semibold text-lg">{t('common.error', { defaultValue: 'Ошибка конфигурации' })}</div>
      </div>
    );
  }

  // Состояние загрузки
  if (userRole === undefined || userRole === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-blue-500 font-semibold text-lg">{t('common.loading')}</div>
      </div>
    );
  }

  // Проверка доступа
  const hasAccess = requiredRoles.includes(userRole);
  
  if (!hasAccess) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500 font-semibold text-lg">
          {t('common.error', { defaultValue: 'Доступ запрещён' })}. {t('login.role')}: {requiredRoles.join(', ')}
        </div>
      </div>
    );
  }

  // Безопасный рендеринг children
  try {
    return React.Children.only(children);
  } catch (error) {
    console.error('ProtectedRoute: ошибка рендеринга children', error);
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500 font-semibold text-lg">{t('common.error', { defaultValue: 'Ошибка отображения контента' })}</div>
      </div>
    );
  }
};

export default ProtectedRoute;